export const toMimecastInputCreateRequest = ({
  baseUrl,
  mimecastName,
  accessKey,
  secretKey,
  applicationId,
  applicationKey,
  contentTypes,
  mimecastThrottleEnabled,
  pollingInterval
}) => {
  var _a;
  return {
    base_url: baseUrl == null ? void 0 : baseUrl.value,
    name: mimecastName == null ? void 0 : mimecastName.value,
    access_key: accessKey == null ? void 0 : accessKey.value,
    secret_key: secretKey == null ? void 0 : secretKey.value,
    application_id: applicationId == null ? void 0 : applicationId.value,
    application_key: applicationKey == null ? void 0 : applicationKey.value,
    content_type: (_a = contentTypes == null ? void 0 : contentTypes.value) == null ? void 0 : _a.split(","),
    enable_throttling: !!(mimecastThrottleEnabled == null ? void 0 : mimecastThrottleEnabled.value),
    polling_interval: pollingInterval == null ? void 0 : pollingInterval.value,
    polling_time_unit: "MINUTES"
  };
};
export const toGenericInputCreateRequest = ({
  mimecastName,
  baseUrl,
  accessKey,
  secretKey,
  applicationId,
  applicationKey,
  mimecastThrottleEnabled,
  pollingInterval,
  contentTypes
}) => ({
  type: "org.graylog.enterprise.integrations.mimecast.MimecastInput",
  title: mimecastName.value,
  global: false,
  configuration: {
    base_url: baseUrl.value,
    access_key: accessKey.value,
    secret_key: secretKey.value,
    application_id: applicationId.value,
    application_key: applicationKey.value,
    content_type: contentTypes.value.split(","),
    throttling_allowed: !!(mimecastThrottleEnabled == null ? void 0 : mimecastThrottleEnabled.value),
    polling_interval: pollingInterval.value,
    polling_time_unit: "MINUTES"
  }
});
